import { useQuery } from '@tanstack/react-query';
import { documentsService } from '../services/documents.service';
import { useEffect, useState } from 'react';

/**
 * Hook pour prévisualiser un document
 * Récupère le fichier en tant que blob et crée un object URL
 */
export const useDocumentPreview = (uuid: string | undefined) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const { data: blob, isLoading, error } = useQuery({
    queryKey: ['document-preview', uuid],
    queryFn: () => documentsService.downloadDocument(uuid!),
    enabled: !!uuid,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  useEffect(() => {
    // Créer l'object URL quand le blob est disponible
    if (blob) {
      const url = window.URL.createObjectURL(blob);
      setPreviewUrl(url);

      // Nettoyer l'URL quand le composant est démonté ou le blob change
      return () => {
        window.URL.revokeObjectURL(url);
      };
    }
  }, [blob]);

  return {
    previewUrl,
    isLoading,
    error,
  };
};
